import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import Reveal from '../components/animations/Reveal';

const faqs = [
  { question: 'What are Cry toxins?', answer: 'Cry toxins are proteins produced by the bacterium Bacillus thuringiensis that have insecticidal properties. They are highly specific to certain insect pests and are widely used in agriculture to protect crops.' },
  { question: 'How does CryMiner improve upon existing tools?', answer: 'CryMiner improves upon tools like BtToxin_Digger and CryProcessor by using a comprehensive cry gene database and full-length nucleotide data for more accurate identification. It also employs an advanced search algorithm (BLAST) for efficient genome sequence comparison.' },
  { question: 'What types of sequences can I upload?', answer: 'CryMiner supports various input data types, including raw Illumina/PacBio/ONT reads and assembled genome sequences. The tool can handle FASTQ, FASTA, and compressed file formats.' },
  { question: 'What kind of results can I expect?', answer: 'CryMiner provides detailed reports on identified cry toxin genes, including their sequences, functions, and sources. The results include information on the primary structures and potential three-dimensional models of the toxins.' },
  { question: 'How does CryMiner ensure data accuracy?', answer: 'CryMiner ensures accuracy by using a curated database of cry genes compiled from published literature and contributions from researchers worldwide. The advanced search algorithm rigorously compares input sequences against this database.' },
  { question: 'Can CryMiner handle large datasets?', answer: 'Yes, CryMiner is designed to handle large datasets efficiently, supporting high-throughput sequencing data with optimized assembly workflows and scalable analysis pipelines.' },
];

const FAQsPage = () => {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center mb-12">
            <h2 className="font-display text-4xl font-bold text-slate-900 mb-6">Frequently Asked <span className="text-brand">Questions</span></h2>
            <p className="text-xl text-slate-600">Find answers to common questions about CryMiner</p>
          </div>
        </Reveal>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const open = openFaq === index;
            return (
              <Reveal key={index} delay={index * 70}>
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden hover:border-brand transition-colors">
                  <button onClick={() => setOpenFaq(open ? -1 : index)} className="w-full flex items-center justify-between text-left p-6 group">
                    <h3 className="font-display text-lg font-semibold text-slate-900 group-hover:text-brand transition-colors pr-4">{faq.question}</h3>
                    <ChevronDown className={`w-5 h-5 text-brand flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
                  </button>
                  <div className="grid transition-all duration-400 ease-out" style={{ gridTemplateRows: open ? '1fr' : '0fr' }}>
                    <div className="overflow-hidden">
                      <p className="px-6 pb-6 text-slate-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;
